export default __webpack_public_path__ + "static/pragicts-automation-banner-efficiency-13c366a9d7a2ebccd76d0693de3485a0.jpg";